import CourseInstanceCard from './component'
export default CourseInstanceCard
